import { CdkDragDrop, moveItemInArray, CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';
import { Component, OnInit, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Sorting } from '@model/ftf-api.model';


export interface SortCriteria {
  id: string;
  field: Sorting.SortByEnum;
  direction: Sorting.DirectionEnum;
}

export const defaultSortCriteria: SortCriteria[] = [
  {
    id: '1',
    field: Sorting.SortByEnum.DOCUMENT_DATE.value,
    direction: Sorting.DirectionEnum.DESC.value,
  },
  {
    id: '2',
    field: Sorting.SortByEnum.TITLE.value,
    direction: Sorting.DirectionEnum.ASC.value,
  },
  {
    id: '3',
    field: Sorting.SortByEnum.FILE_NAME.value,
    direction: Sorting.DirectionEnum.ASC.value,
  },
  {
    id: '4',
    field: Sorting.SortByEnum.DOCUMENT_SUB_TYPE.value,
    direction: Sorting.DirectionEnum.ASC.value,
  },
];

@Component({
  selector: 'app-sorting',
  templateUrl: './sort-setting.component.html',
  styleUrls: ['./sort-setting.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SortingComponent),
      multi: true,
    },
  ],
  imports: [
    MatLabel,
    MatIcon,
    MatTooltip,
    CdkDropList,
    CdkDrag
  ],
})
export class SortingComponent implements OnInit, ControlValueAccessor {
  sorting = Sorting;

  sortCriteria: SortCriteria[] = [];

  @Output() criteriaChanged = new EventEmitter<SortCriteria[]>();

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};
  disabled = false;

  constructor() {}

  ngOnInit(): void {
    if (this.sortCriteria.length === 0) {
      this.initializeDefaultCriteria();
    }
  }

  private initializeDefaultCriteria(): void {
    this.sortCriteria = defaultSortCriteria.map((criteria) => ({ ...criteria }));
  }

  drop(event: CdkDragDrop<SortCriteria[]>): void {
    moveItemInArray(this.sortCriteria, event.previousIndex, event.currentIndex);
    this.emitChange();
  }

  setDirection(criteria: SortCriteria, direction: Sorting.DirectionEnum): void {
    criteria.direction = direction;
    this.emitChange();
  }

  getSortByLabel(field: Sorting.SortByEnum): string {
    const option = Object.values(Sorting.SortByEnum).find((opt) => opt.value === field);
    return option ? option.label : field;
  }

  private emitChange(): void {
    this.onChange(this.sortCriteria);
    this.onTouched();

    this.criteriaChanged.emit([...this.sortCriteria]);
  }

  writeValue(value: SortCriteria[]): void {
    if (value && value.length > 0) {
      this.sortCriteria = value;
    } else {
      this.initializeDefaultCriteria();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
